import Joi from 'joi';
import { useState } from 'react';

export const useFormValidation = <T>(validationSchema: Joi.ObjectSchema<any>) => {
  const [errors, setErrors] = useState<Partial<Record<keyof T, string>>>({});

  const validate = (body: Record<any, any>) => {
    const { error } = validationSchema.validate(body, { abortEarly: false });
    if (error) {
      const validationErrors: Partial<Record<keyof T, string>> = {};
      error.details.forEach((detail) => {
        if (detail?.context?.key) {
          validationErrors[detail.context.key as keyof T] = detail.message;
        }
      });

      setErrors(validationErrors);
      return false;
    }
    setErrors({});
    return true;
  };

  return { errors, setErrors, validate };
};
